import { Outlet } from 'react-router-dom';

import { DashboardSideMenu } from '../../components/DashboardSideMenu';

import useAuthStore from '../../store/auth';

import { Container, Page } from './styles';

export function Home() {
  const menuSelected = useAuthStore(state => state.menuSelected);

  const getMenuSelected = () => {
    if (menuSelected === 'portal') return <DashboardSideMenu />;
    return '';
  };

  return (
    <Container>
      {getMenuSelected()}
      <Page>
        <Outlet />
      </Page>
    </Container>
  );
}
